import React from 'react';
import { Home, Shield, Target, Sparkles } from 'lucide-react';
import { useTheme } from '@/context/ThemeContext';
import { assetUrl } from '@/lib/store';

export default function MobileBottomNav({ activeTab, onTabChange, onMore }) {
  const {iconMapping}=useTheme();
  const navItems = [
    { id: 'home', label: 'الرئيسية', icon: Home, iconKey:'home' },
    { id: 'money', label: 'الأموال', icon: Shield, iconKey:'money' },
    { id: 'goals', label: 'الأهداف', icon: Target, iconKey:'goals' },
    { id: 'family_ai', label: 'AI', icon: Sparkles, iconKey:'family_ai' },
    { id: 'more', label: 'المزيد', icon: Sparkles, iconKey:'settings' }
  ];

  return (
    <nav className="family-mobile-nav md:hidden fixed bottom-0 inset-x-0 z-40 px-2 pt-1.5 pb-[calc(.375rem+env(safe-area-inset-bottom))]" aria-label="التنقل الرئيسي">
      <div className="flex items-center justify-around max-w-md mx-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
            onClick={() => item.id === 'more' ? onMore?.() : onTabChange(item.id)}
            aria-label={item.label}
              className={`min-h-12 min-w-12 flex flex-col items-center justify-center py-1.5 px-3 rounded-2xl transition-all duration-200 ${
                isActive
                  ? 'text-[var(--brand-champagne)] font-black scale-105'
                  : 'text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] font-medium'
              }`}
            >
              <div className={`p-1 rounded-xl transition-colors ${
                isActive ? 'bg-[var(--brand-champagne)]/10 text-[var(--brand-champagne)] ring-1 ring-[var(--brand-champagne)]/30' : ''
              }`}>
                {assetUrl(iconMapping?.[item.iconKey])?<img src={assetUrl(iconMapping[item.iconKey])} alt="" className="h-5 w-5 object-contain"/>:<Icon className={`w-5 h-5 ${isActive ? 'stroke-[2.5]' : 'stroke-[1.75]'}`} />}
              </div>
              <span className="text-[10px] mt-0.5">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
